import transitionEmit from './transitionEmit.js';
export default function transitionStart() {
  let runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  let direction = arguments.length > 1 ? arguments[1] : undefined;
  const swiper = this;
  const params = swiper.params;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}